import { BREAKPOINTS as _BREAKPOINTS } from './breakpoints.js'
/* eslint-disable */

// ENVIRONMENT
export const ENV = __ENV__
export const PROD_DEVTOOLS = __VUE_PROD_DEVTOOLS__
export const MODIO_SITE = import.meta.env.VITE_MODIO_SITE
export const MONETIZATION_BASE_URL = import.meta.env.VITE_MONETIZATION_BASE_URL
export const AUTH_BASE_URL = import.meta.env.VITE_AUTH_URL
export const UI_TEST_ENVS = []
export const MODIO_ENV = ''

export const REPLICATION_DELAY_MS = __REPLICATION_DELAY_MS__
export const API_RESULT_LIMIT = 100
export const ORIGIN = window.location.origin
export const isFrontend = false
export const isEMH = true
export const TILIA_WIDGET_URL = 'https://web.tilia-inc.com/ui/v1/widget'

// ENDPOINTS
export const SKETCHFAB_MODELS_ENDPOINT = 'https://api.sketchfab.com/v3/models'

// PLACEHOLDER IMAGES
export const PLACEHOLDER_CARD_IMAGE = 'https://mod.io/images/placeholder/card.png'
export const PREVIEW_IMAGE_KEY = 'thumb_1280x720'
export const LARGE_CARD_IMAGE_KEY = 'thumb_640x360'
export const CARD_IMAGE_KEY = 'thumb_320x180'

export const LEGAL_AGE = 18
export const NEW_RESOURCE_ID = 'new'
export const IMAGE_CROP_SIZES = [
  '50x50',
  '64x64',
  '100x100',
  '128x128',
  '256x256',
  '320x180',
  '640x360',
  '1280x720',
  '1020x2000',
]

export const PAGINATION_DEFAULT_PAGE = 1
export const PAGINATION_DEFAULT_TOTAL = 0
export const PAGINATION_DEFAULT_LIMIT = 30

// RATINGS
export const RATINGS_LIKE = 1
export const RATINGS_DISLIKE = -1
export const RATINGS_UNDECIDED = 0

// TOAST
export const TOAST_SECONDS = 5

// ACTIVE ONLINE USER
export const ONLINE_USER_TIMEOUT_SECONDS = 600

// Use to redirect after icon animation completes
export const BUTTON_ANIMATION_DURATION = 2000
export const BUTTON_ICON_ANIMATION_DURATION = BUTTON_ANIMATION_DURATION - 500

// COMMENTS
export const MAX_DISCUSSION_LEVEL = 30
export const MAX_PINNED_COMMENT_LIMIT = 3
export const HIDE_COMMENT_BELOW_KARMA = -5
export const CLEAN_COMMENT_LINKS_BELOW_KARMA = -2

// MODFILES
export const MAX_STANDARD_MOD_FILE_SIZE = 500 * 1024 * 1024
export const MAX_MULTIPART_PART_SIZE = 50 * 1024 * 1024
export const PROGRESS_100_PERCENT = 1
export const MAX_FILE_COUNT = 10

// METRICS
export const METRIC_GAME_HEADER = 'X-Modio-Game'
export const METRIC_GUIDE_HEADER = 'X-Modio-Guide'
export const METRIC_COLLECTION_HEADER = 'X-Modio-Collection'

// LOCALE
export const LOCALE_LANGUAGE = 'en-US'

export const BREAKPOINTS = _BREAKPOINTS
export const PHP_UNIXTIME_LEN = 10

export const IS_IOS_TOUCH_DEVICE =
  [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod',
  ].includes(navigator.platform) ||
  // iPad on iOS 13 detection
  (navigator.userAgent.includes('Mac') && 'ontouchend' in document)

export const MIN_PAGE_HEIGHT = 620

export const CACHE_TIME_SECONDS = 120
